import { render, staticRenderFns } from "./SocialSharePopup.vue?vue&type=template&id=53fd1a04&scoped=true"
import script from "./SocialSharePopup.vue?vue&type=script&lang=js"
export * from "./SocialSharePopup.vue?vue&type=script&lang=js"
import style0 from "./SocialSharePopup.vue?vue&type=style&index=0&id=53fd1a04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fd1a04",
  null
  
)

export default component.exports